import { render, staticRenderFns, recyclableRender, components } from "./my-collection.vue?vue&type=template&id=8a541174&scoped=true&"
var renderjs
import script from "./my-collection.vue?vue&type=script&lang=js&"
export * from "./my-collection.vue?vue&type=script&lang=js&"
import style0 from "./my-collection.vue?vue&type=style&index=0&lang=css&"
import style1 from "./my-collection.vue?vue&type=style&index=1&id=8a541174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a541174",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/my-collection/my-collection.vue"
export default component.exports